import { removeInvalidItems } from '@/services/adapters/transformations/removeInvalidItems'
import { IDataStore } from '@/services/dataStore/IDataStore'
import { retryTimeouts } from '@/services/dataStore/retryTimeouts'
import useDataStore from '@/services/dataStore/useDataStore'
import { BaseDataLayerSchema, IBaseDataLayer } from '@lifk/types'
import useSWRV from 'swrv'
import { z } from 'zod'

const useGetDataLayers = () => {
  const {
    dataStore,
    dataStoreSWRVKey,
    handleDataStoreError,
    disableValidations
  } = useDataStore()

  async function getDataLayers(
    dataStore: IDataStore
  ): Promise<IBaseDataLayer[]> {
    try {
      const response = await retryTimeouts(() => dataStore.getDataLayers())

      const validation = z.array(BaseDataLayerSchema).safeParse(response)
      let dataLayers: IBaseDataLayer[] = validation.data ?? []
      if (!validation.success) {
        dataLayers = removeInvalidItems(
          response,
          validation.error,
          disableValidations.value
        )
      }

      return dataLayers
    } catch (e) {
      handleDataStoreError(e, 'dataLayers')
      throw e
    }
  }

  const result = useSWRV(
    () => `/data-layers/${dataStoreSWRVKey.value.perspective}`,
    async () => {
      return await getDataLayers(dataStore.value)
    },
    {
      // 30s for adapters to prevent too many API calls to paid CMS's
      dedupingInterval: 30000,
      shouldRetryOnError: false
    }
  )
  return result
}

export { useGetDataLayers }
